<template>
  <div class="receive-action">
    <div class="receive-action-page-title">Receive</div>
    <div class="receive-action-count-row">
      <div
        v-for="n in receiveCount"
        :key="n"
        class="receive-action-count"
        :class="{ 'receive-action-count-lost': n < receiveCount }"
      >#{{ n }}</div>
    </div>
    <div class="receive-player-rows">
      <div class="receive-primary-row">
        <div  
          v-for="item in passingUnitPlayers"
          :key="getPlayerKey(item)"
          class="receive-player-card receive-primary-player-card"
        >
          <img
            v-if="item.player && item.player.photo"
            class="receive-player-photo"
            :src="getPhotoUrl(item.player)"
            :alt="item.player.name"
          />
          <div class="receive-player-info">
            <span v-if="item.player" class="receive-player-number">
              {{ item.player.number }}
            </span>
            <span class="receive-player-name">
              {{ item.player ? item.player.name : 'None' }}
            </span>
            <span v-if="item.roleCode" class="receive-player-role">{{ item.roleCode }}</span>
          </div>
          <div class="receive-player-stats">
            <div class="receive-player-stats-rating">{{ getPlayerStats(item.player).rating }}</div>
            <div class="receive-player-stats-breakdown">
              <div v-for="r in [3, 2, 1, 0]" :key="r" class="receive-player-stats-box" :class="'rating-' + r">
                <span class="receive-player-stats-count">{{ getPlayerStats(item.player)['r' + r] }}</span>
                <span class="receive-player-stats-pct">{{ getPlayerStats(item.player).total ? Math.round(getPlayerStats(item.player)['r' + r] / getPlayerStats(item.player).total * 100) : 0 }}%</span>
              </div>
            </div>
          </div>
          <div class="receive-player-rating">
            <button
              v-for="rating in [3, 2, 1, 0]"
              :key="rating"
              class="receive-player-rating-button"
              :class="{
                error: rating === 0
              }"
              :disabled="Boolean(selectedCall)"
              @click="selectPlayerAndRating(item.player, rating)"
            >
              {{ rating === 0 ? 'Pass error' : rating }}
            </button>
          </div>
        </div>
      </div>
      <div class="receive-secondary-row">
        <div
          v-for="item in supportPlayers"
          :key="getPlayerKey(item)"
          class="receive-player-card receive-secondary-player-card"
          :class="{ expanded: expandedSupportPlayer === getPlayerKey(item) }"
          @click="toggleSupportPlayer(getPlayerKey(item))"
        >
          <img
            v-if="item.player && item.player.photo"
            class="receive-player-photo"
            :src="getPhotoUrl(item.player)"
            :alt="item.player.name"
          />
          <div class="receive-player-info">
            <span v-if="item.player" class="receive-player-number">
              {{ item.player.number }}
            </span>
            <span class="receive-player-name">
              {{ item.player ? item.player.name : 'None' }}
            </span>
            <span v-if="item.roleCode" class="receive-player-role">{{ item.roleCode }}</span>
          </div>
          <div v-if="expandedSupportPlayer !== getPlayerKey(item)" class="receive-player-stats">
            <div class="receive-player-stats-rating" :class="{ 'inactive': !getPlayerStats(item.player).total > 0 }">{{ getPlayerStats(item.player).rating }}</div>
          </div>
          <div v-if="expandedSupportPlayer === getPlayerKey(item)" class="receive-player-rating">
            <button
              v-for="rating in [3, 2, 1, 0]"
              :key="rating"
              class="receive-player-rating-button"
              :class="{
                error: rating === 0
              }"
              :disabled="Boolean(selectedCall)"
              @click.stop="selectPlayerAndRating(item.player, rating)"
            >
              {{ rating === 0 ? 'Pass error' : rating }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="receive-other-outcomes">
      <div class="receive-outcome-won">
        <div class="serve-error">
          <label
            :for="'player-opp-serve-error'"
            class="receive-outcome-button primary won"
          >
            <input
              type="radio"
              id="player-opp-serve-error"
              :value="{ name: 'Opp. serve error' }"
              v-model="selectedPlayer"
              @click="togglePlayer({ name: 'Opp. serve error' }, $event)"
            />
            Opp. serve error
          </label>
        </div>
        <div class="serve-rotation-error">
          <label
            class="receive-outcome-button secondary won"
          >
            <input
              type="radio"
              value="Opposition Rotation Error"
              v-model="selectedCall"
              @click="toggleCall('Opposition Rotation Error', $event)"
            />
            Opposition rotation error
          </label>
        </div>
      </div>
      <div class="receive-outcome-lost">
        <div class="team-receive-error">
          <label
            :for="'team-receive-error'"
            class="receive-outcome-button primary lost"
          >
            <input
              type="radio"
              id="team-receive-error"
              :value="'Team receive error'"
              v-model="selectedPlayer"
              @click="togglePlayer('Team receive error', $event)"
            />
            Team receive error
          </label>
        </div>
        <div class="serve-rotation-error">
          <label
            class="receive-outcome-button secondary lost"
          >
            <input
              type="radio"
              value="Rotation Error"
              v-model="selectedCall"
              @click="toggleCall('Rotation Error', $event)"
            />
            Team rotation error
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '../store.js';

export default {
  name: 'ReceiveAction',
  props: {
    currentPoint: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedPlayer: this.currentPoint?.receiveAction?.player || null,
      selectedRating: this.currentPoint?.receiveAction?.rating ?? null,
      selectedCall: this.currentPoint?.receiveAction?.call ?? null,
      expandedSupportPlayer: null
    };
  },
  computed: {
    receiveCount() {
      const points = store.getCurrentSet()?.points || [];
      let count = 1;
      for (let i = points.length - 1; i >= 0; i--) {
        if (points[i].startPoint === 'Receive') {
          count++;
        } else {
          break;
        }
      }
      return count;
    },
    currentLineup() {
      return store.currentLineup;
    },
    libero() {
      return store.currentLibero;
    },
    onCourtNumbers() {
      const numbers = this.currentPoint?.currentOnCourtNumbers;
      return Array.isArray(numbers) ? numbers : [];
    },
    isLiberoOnCourt() {
      if (!this.libero) return false;
      if (this.onCourtNumbers.includes(this.libero.number)) return true;
      // Fallback: check currentLiberoNumber in case store.currentLibero was updated but onCourtNumbers hasn't re-synced
      const pointLiberoNumber = this.currentPoint?.currentLiberoNumber;
      return Boolean(pointLiberoNumber && this.onCourtNumbers.includes(pointLiberoNumber));
    },
    activeLibero() {
      if (!this.libero) return null;
      if (this.onCourtNumbers.includes(this.libero.number)) return this.libero;
      // If currentLiberoNumber is on court but doesn't match store.currentLibero, find from roster
      const pointLiberoNumber = this.currentPoint?.currentLiberoNumber;
      if (pointLiberoNumber && this.onCourtNumbers.includes(pointLiberoNumber)) {
        const rosterMatch = store.match?.roster?.find(p => p.number === pointLiberoNumber);
        return rosterMatch || { number: pointLiberoNumber, name: '', role: 'libero' };
      }
      return null;
    },
    onCourtPlayers() {
      const onCourtNumbers = this.onCourtNumbers;
      return this.currentLineup
        .filter(item => item && item.player)
        .filter(item => !onCourtNumbers.length || onCourtNumbers.includes(item.player.number))
        .slice()
        .sort((a, b) => a.rotationPosition - b.rotationPosition);
    },
    onCourtPlayersWithLibero() {
      const basePlayers = this.onCourtPlayers.slice();
      const libero = this.activeLibero;
      if (!this.isLiberoOnCourt || !libero) {
        return basePlayers;
      }
      const alreadyIncluded = basePlayers.some(item => item.player && item.player.number === libero.number);
      if (!alreadyIncluded) {
        basePlayers.push({ player: libero, rotationPosition: 'libero', roleCode: 'L' });
      }
      return basePlayers;
    },
    passingUnitPlayers() {
      const rotationCode = this.currentPoint?.currentRotationCode || '';
      const order = this.getPassingUnitOrder(rotationCode);
      const onCourt = this.onCourtPlayersWithLibero;
      const outsidePlayers = onCourt.filter(item => this.getPlayerRole(item) === 'outside');
      const frontOH = outsidePlayers.find(item => this.isFrontRow(item.rotationPosition)) || null;
      const backOH = outsidePlayers.find(item => this.isBackRow(item.rotationPosition)) || null;
      const libero = this.activeLibero;
      const liberoItem = this.isLiberoOnCourt && libero
        ? onCourt.find(item => item.player && item.player.number === libero.number) || {
          player: libero,
          rotationPosition: 'libero',
          roleCode: 'L'
        }
        : null;

      const typeMap = {
        frontOH,
        backOH,
        libero: liberoItem
      };

      const selected = [];
      order.forEach(type => {
        const entry = typeMap[type];
        if (entry) {
          selected.push(entry);
        }
      });

      const used = new Set(selected.map(item => this.getPlayerKey(item)));
      const remaining = onCourt.filter(item => !used.has(this.getPlayerKey(item)));
      const needed = Math.max(0, 3 - selected.length);
      if (needed) {
        selected.push(...remaining.slice(0, needed));
      }

      return selected;
    },
    supportPlayers() {
      const onCourt = this.onCourtPlayersWithLibero;
      const used = new Set(this.passingUnitPlayers.map(item => this.getPlayerKey(item)));
      return onCourt.filter(item => !used.has(this.getPlayerKey(item)));
    },
    playerReceiveStats() {
      const stats = new Map();
      const sets = store.match?.sets || [];
      for (const set of sets) {
        const points = set.points || [];
        for (const point of points) {
          const ra = point.receiveAction;
          if (!ra || !ra.player || !ra.player.number || ra.rating == null) continue;
          const num = ra.player.number;
          if (!stats.has(num)) {
            stats.set(num, { total: 0, r3: 0, r2: 0, r1: 0, r0: 0, rating: '0.00' });
          }
          const s = stats.get(num);
          s.total++;
          if (ra.rating === 3) s.r3++;
          else if (ra.rating === 2) s.r2++;
          else if (ra.rating === 1) s.r1++;
          else if (ra.rating === 0) s.r0++;
          const denom = s.r3 + s.r2 + s.r1 + s.r0;
          s.rating = denom > 0 ? ((s.r3 * 3 + s.r2 * 2 + s.r1 * 1) / denom).toFixed(2) : '0.00';
        }
      }
      return stats;
    }
  },
  methods: {
    getPlayerStats(player) {
      if (!player || !player.number) return { total: 0, r3: 0, r2: 0, r1: 0, r0: 0, rating: '0.00' };
      return this.playerReceiveStats.get(player.number) || { total: 0, r3: 0, r2: 0, r1: 0, r0: 0, rating: '0.00' };
    },
    toggleSupportPlayer(key) {
      this.expandedSupportPlayer = this.expandedSupportPlayer === key ? null : key;
    },
    selectPlayerAndRating(player, rating) {
      // Toggle behavior: if clicking same player+rating, deselect
      if (this.selectedPlayer?.number === player.number && this.selectedRating === rating) {
        this.selectedPlayer = null;
        this.selectedRating = null;
      } else {
        this.selectedPlayer = player;
        this.selectedRating = rating;
      }

      // Clear any rotation error call
      this.selectedCall = null;

      // Immediately emit to parent
      this.updateSelection();
    },
    getPhotoUrl(player) {
      try {
        if (player && player.photo) {
          return require(`@/assets/${player.photo}`);
        }
        return require('@/assets/player-photos/placeholder.png');
      } catch (error) {
        return require('@/assets/player-photos/placeholder.png');
      }
    },
    getPassingUnitOrder(rotationCode) {
      const map = {
        P1: ['backOH', 'libero', 'frontOH'],
        P2: ['frontOH', 'backOH', 'libero'],
        P3: ['frontOH', 'libero', 'backOH'],
        P4: ['frontOH', 'backOH', 'libero'],
        P5: ['frontOH', 'backOH', 'libero'],
        P6: ['frontOH', 'libero', 'backOH']
      };
      return map[rotationCode] || ['frontOH', 'libero', 'backOH'];
    },
    getPlayerRole(item) {
      if (!item) {
        return '';
      }
      if (item.roleCode === 'OH') {
        return 'outside';
      }
      if (item.roleCode === 'OP') {
        return 'opposite';
      }
      if (item.roleCode === 'MB') {
        return 'middle';
      }
      if (item.roleCode === 'S') {
        return 'setter';
      }
      if (item.player && item.player.role) {
        return item.player.role;
      }
      return '';
    },
    isFrontRow(rotationPosition) {
      const position = Number(rotationPosition);
      return Number.isFinite(position) && [2, 3, 4].includes(position);
    },
    isBackRow(rotationPosition) {
      const position = Number(rotationPosition);
      return Number.isFinite(position) && [1, 5, 6].includes(position);
    },
    getPlayerKey(item) {
      if (!item || !item.player) {
        return String(item?.rotationPosition ?? 'unknown');
      }
      return String(item.player.id ?? item.player.number ?? item.rotationPosition);
    },
    updateSelection() {
      if (this.selectedPlayer) {
        this.selectedCall = null;
      }
      if (this.selectedCall) {
        this.$emit('update-first-set', 'receiveAction', {
          player: {},
          rating: null,
          call: this.selectedCall
        });
        return;
      }
      if (this.selectedPlayer && this.selectedPlayer.name === 'Opp. serve error') {
        this.$emit('update-first-set', 'receiveAction', { 
          player: this.selectedPlayer, 
          rating: null, 
          call: null,
          pointOutcome: 'Won', 
          pointDetail: 'Opp. serve error',
        });
      } else if (this.selectedPlayer === 'Team receive error') {
        this.$emit('update-first-set', 'receiveAction', {
          player: this.selectedPlayer,
          rating: 0,
          call: null,
          pointOutcome: 'Lost',
          pointDetail: 'Opp. ace',
        });
      } else {
        this.$emit('update-first-set', 'receiveAction', { 
          player: this.selectedPlayer, 
          rating: this.selectedRating,
          call: this.selectedCall
        });
      }
    },
    togglePlayer(player, event) {
      const isSame = this.selectedPlayer === player ||
        (player && this.selectedPlayer && player.name && this.selectedPlayer.name === player.name);
      if (isSame) {
        event.preventDefault();
        this.selectedPlayer = null;
        this.selectedRating = null;
        this.selectedCall = null;
        this.updateSelection();
        return;
      }
      this.selectedPlayer = player;
      this.selectedCall = null;
      this.updateSelection();
    },
    toggleCall(call, event) {
      if (this.selectedCall === call) {
        event.preventDefault();
        this.selectedCall = null;
        this.updateSelection();
        return;
      }
      this.selectedCall = call;
      this.selectedRating = null;
      this.selectedPlayer = null;
      this.updateSelection();
    },
    isSelected(player) {
      if (player.name === 'Opp. serve error') {
        return this.selectedPlayer && this.selectedPlayer.name === 'Opp. serve error';
      }
      if (player === 'Team receive error') {
        return this.selectedPlayer === 'Team receive error';
      }
      return this.selectedPlayer === player;
    },
    resetSelectedPlayer() {
      this.selectedPlayer = null;
      this.selectedRating = null;
      this.selectedCall = null;
    }
  },
  watch: {
    'currentPoint.receiveAction': {
      handler(nextAction) {
        if (!nextAction) {
          this.selectedPlayer = null;
          this.selectedRating = null;
          this.selectedCall = null;
          return;
        }
        // Check if player is null, empty object, or has no meaningful data
        const player = nextAction.player;
        const hasPlayer = player &&
          player !== null &&
          typeof player === 'object' &&
          Object.keys(player).length > 0 &&
          (player.name || player.number !== undefined) &&
          player.name !== '';

        this.selectedPlayer = hasPlayer ? player : null;
        this.selectedRating = nextAction.rating ?? null;
        this.selectedCall = nextAction.call ?? null;
      },
      deep: true,
      immediate: false
    }
  }
};
</script>

<style lang="scss">
.receive-action {
  --receive-player-card-min-height: 300px;
  --receive-player-card-padding-top: 120px;
  --receive-player-card-before-top: 100px;
  --receive-player-number-font-size: 16px;
  --receive-player-number-dimensions: 30px;
  --receive-player-name-font-size: 16px;
  --receive-player-photo-height: 100%;
  --receive-player-photo-left: -70px;
  --receive-player-photo-scale: scale(1);

  padding: 0 10px 120px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

.receive-action-page-title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
}

.receive-action-count-row {
  display: flex;
  gap: 6px;
  align-items: center;
  margin: 0 0 12px 0;
}

.receive-action-count {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 11px;
  color: var(--white);
  font-weight: 500;
  border-radius: 40px;
  // background-color: var(--grey-500);
  border: 1px dashed rgb(from var(--white) r g b / 0.5);
  flex-shrink: 0;
}

.receive-action-count-lost{
  background-color: var(--red-400);
  border-color: var(--red-400);
  color: var(--white);
}

.receive-player-rows {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.receive-primary-row {
  display: flex;
  gap: 10px;
  width: 100%;
}

.receive-secondary-row {
  display: flex;
  gap: 10px;
  width: 100%;
  max-width: 900px;
}

.receive-player-card {
  color: var(--grey-900);
  border-radius: 20px;
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-end;
  position: relative;
  overflow: hidden;
  flex-direction: column;
  box-sizing: border-box;
  padding-top: var(--receive-player-card-padding-top);
  transition: all 0.2s cubic-bezier(.4,0,0,1);
  min-height: var(--receive-player-card-min-height);

  &::before {
    content: '';
    position: absolute;
    background-color: var(--grey-20);
    bottom: 0;
    top: var(--receive-player-card-before-top);
    left: 0;
    right: 0;
    border-radius: 20px;
    z-index: -1;
    transition: background-color 0.5s cubic-bezier(.4,0,0,1);
  }

  &::after {
    content: '';
    position: absolute;
    background: linear-gradient(
      0deg,
      rgb(from var(--grey-1000) r g b / 0.15) 0%,
      rgb(from var(--grey-1000) r g b / 0) 50%
    );
    inset: 0;
    top: var(--receive-player-card-before-top);
    bottom: 0;
    left: 0;
    right: 0;
  }

  &:hover,
  &.expanded {
    --receive-player-photo-scale: scale(1.1);
  }

  &:hover {
    &::before {
      background-color: var(--grey-100);
    }
  }
}

.receive-secondary-player-card {
  --receive-player-card-padding-top: 14px;
  --receive-player-card-before-top: 0px;
  --receive-player-card-min-height: 126px;
  --receive-player-number-font-size: 14px;
  --receive-player-number-dimensions: 24px;
  --receive-player-name-font-size: 14px;
  --receive-player-photo-height: 50%;
  --receive-player-photo-left: -10px;
  cursor: pointer;

  &::before {
    top: var(--receive-player-card-before-top);
  }
}

.receive-player-photo {
  position: absolute;
  bottom: 0;
  left: var(--receive-player-photo-left);
  height: var(--receive-player-photo-height);
  transform: var(--receive-player-photo-scale);
  object-fit: cover;
  transition: transform 0.5s cubic-bezier(.4,0,0,1);
}


.receive-player-info {
  font-weight: 500;
  padding: 0 18px;
  border-radius: 100px;
  font-size: 12px;
  display: flex;
  gap: 8px;
  align-items: center;
  overflow: hidden;
  z-index: 2;
}

.receive-player-number {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  background-color: var(--white);
  border: 1px solid var(--grey-200);
  background: var(--grey-5);
  margin: 0;
  letter-spacing: -0.025rem;
  font-weight: 600;
  font-size: var(--receive-player-number-font-size);
  width: var(--receive-player-number-dimensions);
  height: var(--receive-player-number-dimensions);
}

.receive-player-name {
  font-weight: 700;
  font-size: var(--receive-player-name-font-size);
}

.receive-player-role {
  width: 30px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  background-color: var(--grey-50);
  border-radius: 4px;
}

.receive-player-stats {
  z-index: 2;
  padding: 8px 16px 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.receive-player-stats-rating {
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  color: var(--grey-900);
  letter-spacing: -0.05em;

  &.inactive {
    color: rgb(from var(--grey-900) r g b / 0.35);
  }
}

.receive-player-stats-breakdown {
  display: flex;
  gap: 8px;
  flex: 1;
}

.receive-player-stats-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  border-radius: 10px;
  background-color: rgb(from var(--grey-1000) r g b / 0.02);
  padding: 0;
  width: 50px;
  height: 35px;
  box-sizing: border-box;

  &.rating-0 {
    background: rgb(from var(--red-25) r g b / 1);

    .receive-player-stats-count {
      color: var(--red-500);
    }
    .receive-player-stats-pct {
      color: rgb(from var(--red-500) r g b / 0.35);
    }
  }
}

.receive-player-stats-count {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  color: var(--grey-900);
}

.receive-player-stats-pct {
  font-size: 10px;
  font-weight: 500;
  color: rgb(from var(--grey-900) r g b / 0.35);
  line-height: 1.2;
}

.receive-player-stats-inline {
  font-size: 13px;
  font-weight: 800;
  color: var(--grey-500);
  margin-left: auto;
  letter-spacing: -0.05em;
}

.receive-player-rating {
  display: flex;
  align-items: center;
  width: 100%;
  z-index: 2;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 16px;
}

.receive-player-rating-button {
  width: 50px;
  height: 50px;
  border-radius: 100px;
  padding: 8px;
  box-sizing: border-box;
  background: var(--grey-15);
  font-size: 22px;
  line-height: 1;
  font-weight: 700;
  border: 0;
  color: var(--grey-900);
  cursor: pointer;
  position: relative;
  transition: all 0.1s cubic-bezier(.4,0,0,1);

  &::before {
    content: '';
    position: absolute;
    background-color: var(--grey-1000);
    opacity: 0;
    inset: 0;
    border-radius: 100px;
    z-index: 4;
    transition: opacity 0.2s cubic-bezier(.4,0,0,1);
  }

  &:hover {
    background: var(--white);
    box-shadow: 0 0 0px 8px rgba(0, 0, 0, 0.15), 0 0 8px rgba(0, 0, 0, 0.5);
  }

  &.error {
    background: var(--red-400);
    color: var(--white);
    font-size: 12px;

    &:hover {
      background: var(--red-300);
    }
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}

.receive-other-outcomes {
  position: absolute;
  bottom: 70px;
  left: 10px;
  right: 10px;
  gap: 10px;
  justify-content: space-between;
  display: flex;
}

.receive-outcome-won {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  justify-content: center;
}

.receive-outcome-lost {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  justify-content: center;
}

.receive-outcome-button {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: var(--grey-15);
  align-content: center;
  gap: 10px;
  cursor: pointer;
  aspect-ratio: 1;
  flex-direction: column;
  align-items: center;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;
  text-align: center;
  width: 120px;
  height: 30px;
  padding: 10px;
  font-size: 12px;

  input {
    display: none;
  }

  &.primary {
    &.won {
      background-color: var(--green-500);
      color: var(--white);
      border: 1px solid var(--green-500);

      &:hover {
        background-color: var(--green-600);
        border-color: var(--green-600);
      }
    }

    &.lost {
      background-color: var(--red-300);
      color: var(--white);
      border: 1px solid var(--red-300);

      &:hover {
        background-color: var(--red-400);
        border-color: var(--red-400);
      }
    }
  }

  &.secondary {
    &.won {
      background-color: transparent;
      color: var(--green-500);
      border: 1px solid var(--green-500);

      &:hover {
        color: var(--green-300);
        border: 1px solid var(--green-300);
      }
    }

    &.lost {
      background-color: transparent;
      color: var(--red-200);
      border: 1px solid var(--red-200);

      &:hover {
        color: var(--red-100);
        border: 1px solid var(--red-100);
      }
    }
  }
}

</style>